import React, { useState, useContext, useEffect } from 'react'
import ReactDOM from 'react-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ContentHeader } from '../../layout/Content'
import Searchbar from '../../layout/searchbar/Searchbar'
import ToolbarButton  from '../../layout/ToolbarButton'
import RegisterProductController from '../registerproduct/RegisterProductController'
import FindAndReplaceController from '../../findandreplace/FindAndReplaceController'
import ModalWindow from '../../layout/modalwindow/ModalWindow';
import ProductsListSettingsForm from './ProductsListSettingsForm'
import { appContext } from '../../../App'
import { productsListControllerContext } from './ProductsListController'
import ProductsListHeaderStyle from './css/ProductsListHeaderStyle'

function ProductsToolBarButtons(props) {
  const app = useContext(appContext)
  const setContent = app.content[1]
  const searchProducts = props.searchProducts[0]
  const productsListController = useContext(productsListControllerContext)
  const { setAllCheck, itemsToDelete, deleteSelectedProducts, reloadProductsList, 
    updateSettings, getProductsListSettings, getWarehouses } = productsListController
  const [deleteRecord, setDeleteRecord] = useState(false)
  const [selectAll, setSelectAll] = productsListController.selectAll

  const onClickSettings = () => {
    const productsListSettingsFormProps = {
      getWarehouses,
      getProductsListSettings,
      updateSettings,
      app
    }

    ReactDOM.render(
      <ModalWindow width='30' height='35' id='mw-parent' header='Settings' footer={null}>
        <ProductsListSettingsForm { ...productsListSettingsFormProps } />
      </ModalWindow>,
      document.getElementById('modal-form-container')
    )
  }

  const onAddNewProduct = () => setContent(<RegisterProductController mode={'add'} />)
  const onFindAndReplace = () => setContent(<FindAndReplaceController />)

  const onDeleteSelectedRows = () => setDeleteRecord(true)

  const onSelectAll = () => {
    setSelectAll(!selectAll)
    setAllCheck(!selectAll)
  }

  const onClickMessageBoxYesNo = async (button) => {
    switch(button) {
      case 'Yes':
        await deleteSelectedProducts()
        reloadProductsList()
        setAllCheck(false)
      break
      default:
    }
    ReactDOM.unmountComponentAtNode(document.getElementById('modal-form-container'))
  }

  useEffect(() => {
    if (deleteRecord) {
      ReactDOM.render (
        <ModalWindow
          id='mw-parent'
          width='40'
          height='30'
          header='Delete Product'
          footer={null}>
            <div className='messagebox'>
              <div className='messagebox-content'>
                <div> <span style={{color: 'red'}}>{itemsToDelete.length}</span> record(s) will be deleted. </div>
                <br/>
                <div>Do you want to continue?</div>
              </div>
              <div className='button-container'>
                <button onClick={() => onClickMessageBoxYesNo('No')} className='pospro-action-btn top-anchor'>No</button>
                <button onClick={() => onClickMessageBoxYesNo('Yes')} className='pospro-action-btn bottom-anchor'>Yes</button>
              </div>
            </div>
        </ModalWindow>,
        document.getElementById('modal-form-container')
      )
    }
    return () => setDeleteRecord(false)
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteRecord])

  return (
    <ToolbarButton>
      <button
        type="button"
        className={ searchProducts ? 'pospro-action-btn toolbar-btn disabled-button' : 'pospro-action-btn toolbar-btn' }
        id="refresh-list"
        disabled={searchProducts}
        name="tb"
        onClick={() => reloadProductsList() }
        title='Refresh List'>
        <FontAwesomeIcon icon='sync-alt'/>
        <span className='tooltip-text toolbar-btn'>Refresh list</span>
      </button>
      <button
        type="button"
        className="pospro-action-btn toolbar-btn"
        id="settings"
        name="tb"
        onClick={onClickSettings}
        title='Settings'>
        <FontAwesomeIcon icon='cog'/>
        <span className='tooltip-text'>Settings</span>
      </button>
      <button
        type="button"
        className="pospro-action-btn toolbar-btn show-tb-button"
        id="add-new-product"
        name="tb"
        onClick={onAddNewProduct}
        title='Add new product'>
        <FontAwesomeIcon icon='plus'/>
        <span className='tooltip-text'>Add new product</span>
      </button>
      <button
        type="button"
        className="pospro-action-btn toolbar-btn"
        id="find-and-replace"
        name="tb"
        onClick={onFindAndReplace}
        title='Batch edit'>
        <FontAwesomeIcon icon='edit'/>
        <span className='tooltip-text'>Batch edit</span>
      </button>
      <button
        type="button"
        className={ itemsToDelete.length ? 'pospro-action-btn toolbar-btn' : 'pospro-action-btn disabled-button' }
        id="batch-delete"
        disabled={!itemsToDelete.length}
        name="tb"
        onClick={onDeleteSelectedRows}
        title='Batch delete'>
        <FontAwesomeIcon icon='trash'/>
        <span className='tooltip-text'>Batch delete</span>
      </button>
      <button
        id="select-all"
        type="button"
        className='pospro-action-btn'
        name="tb"
        title="Select/Unselect all current visible items on the list"
        onClick={onSelectAll}>
        {
          (selectAll) ? (<span style={{fontSize: '1rem'}}><FontAwesomeIcon icon='check-square'/>&nbsp;</span>)
          : (<span style={{fontSize: '1rem'}}><FontAwesomeIcon icon='square'/>&nbsp;</span>)
        }
        Select All
      </button>
    </ToolbarButton>
  )
}

function ProductsListHeader() {
  const app = useContext(appContext)
  const [searchProducts, setSearchProducts] = useState('')
  const productsListController = useContext(productsListControllerContext)
  const { filterProducts }  = productsListController
  const warehouse = productsListController.warehouse[0]

  const searchbarProps = {
    search: searchProducts,
    setSearch: setSearchProducts,
    filter: filterProducts,
  }

  return (
    <ContentHeader title={<div>Products List of <span style={{color: '#222'}}>{(warehouse) ? warehouse.name : '...'}</span></div>}>
      <div className="header-container">
        <div id="product-toolbar">
          <Searchbar { ...searchbarProps } />
          <ProductsToolBarButtons searchProducts={searchProducts} />
        </div>
      </div>
      <ProductsListHeaderStyle signed_in={app.client.signed_in}/>
    </ContentHeader>
  )
}

export default React.memo(ProductsListHeader)